export const PropertyPlanRule = (item, value, setData, formType) => {
    if (item && item.field && item.field.id === 'property_plan' && (+formType === 2)) 
    {
         if ((value && value.lookupItemName && value.lookupItemName !== 'Completed') || (value && value.lookupItemId && value.lookupItemId !== 18080))
           setData(null, 0, 'completion_date');
    }
};
